import { useContext } from 'react';

import { LogRocketContext } from 'context/LogRocketProvider';

export default function useLogRocket() {
  const context = useContext(LogRocketContext);

  if (!context) {
    throw new Error('useLogRocket must be used within a LogRocketProvider');
  }

  return context;
}
